import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map, of } from 'rxjs';
import { genericFormInterface } from 'src/app/util/interfaces/genericForm';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { environment } from 'src/environments/environment';
import { mspFileInterface } from 'src/app/util/interfaces/mspFile';

@Injectable({
	providedIn: 'root',
})
export class GenericFormGenService {
	private getSubSelectUrl = environment.baseApiUrl + 'cmdb/subSelect?{qryString}';
	private getFileUrl = environment.baseApiUrl + 'tool/file';

	headers = new HttpHeaders({
		Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
		'Content-Type': 'application/json;charset=UTF-8',
	});

	constructor(
		private http: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	getSubSelect(
		qryName: string,
		value: string,
		parameters: { key: string; value: string }[]
	): Observable<genericFormInterface['items'][number][]> {
		if (qryName == '') return of([]);

		let qryString = `qryName=${qryName}&value=${value}`;
		for (const parameter of parameters) {
			qryString += `&${parameter.key}=${parameter.value}`;
		}
		const getSubSelectUrl = this.getSubSelectUrl.replace('{qryString}', qryString);
		return this.http.get<genericFormInterface['items'][number][]>(getSubSelectUrl, { headers: this.headers });
	}

	getFile(fileName: string, fileSource: 'request' | 'cmdb' | 'km'): Observable<mspFileInterface> {
		return this.http.get(this.getFileUrl, { headers: this.headers, params: { filePath: fileName, fileSource: fileSource } }).pipe(
			map((fileRes: any) => {
				const newMspFile: mspFileInterface = {
					content: fileRes.content,
					name: fileRes.name,
					mimeType: fileRes.mimeType,
					extension: fileRes.extension,
					size: 0,
					file_path: '',
				};

				return newMspFile;
			})
		);
	}
}
